export enum QueryName {
  GetModelYears = 'QSG_GetModelYears',
  GetModelsByYear = 'QSG_GetModelsByYear',
  GetQSGByYearAndModel = 'QSG_GetQSGByYearAndModel',
  GetAllModels = 'QSG_GetAllModels',
  GetQSGNavigation = 'QSG_GetQSGNavigation',
  GetSectionByPath = 'QSG_GetSectionByPath',
  GetAllDisclaimers = 'QSG_GetAllDisclaimers',
}
